import { type CSSObject } from '@emotion/react'
import { camelCase } from 'change-case'
import { Timing } from '../Timing'
import { type TransitionProps } from './types'

/**
 * Like `Transition`, but for the Framer Motion `transition` prop on
 * `<motion.TAGNAME>` components (for example, `<motion.div>`). Use this in
 * combination with `<MotionConfig reducedMotion="user">`.
 *
 * @see https://motion.dev/docs/react-accessibility
 *
 * @note Unlike `Transition` this doesn’t require (or even accept) a
 * `properties` key, because Framer Motion doesn’t support specifying CSS
 * properties.
 *
 * @note This function automatically transforms kebab-case
 * `transition-timing-function` names (for example, `ease-in-out`) to
 * camel case (`easeInOut`), as required by Framer Motion.
 */
export const FramerMotionTransition = ({
  curve = 'ease-in-out',
  delay = 0,
  duration = Timing.Default,
}: Omit<TransitionProps, 'properties'> = {}): CSSObject => ({
  delay,
  // Framer Motion uses seconds instead of milliseconds
  duration: duration / 1000,
  ease: camelCase(curve),
})
